export enum CommunicationChannelContactMethod {
  Telegram = 'TELEGRAM',
  Email = 'EMAIL',
  Phone = 'PHONE',
}
